import {
  FaUserCog,
  FaLock,
  FaShieldAlt,
  FaDatabase,
  FaClipboardCheck,
  FaPeopleArrows,
  FaCogs,
  FaPhoneAlt,
  FaClock,
  FaUsers,
} from "@onemind-services-llc/react-icons-ng/fa";
import { Balancer } from "react-wrap-balancer";

export const PRICING_FEATURES = [
  {
    icon: FaUserCog,
    label: "User & License Provisioning",
    desc: "End-to-end setup for Microsoft 365 accounts, mailboxes, and roles.",
  },
  {
    icon: FaLock,
    label: "Security Configuration",
    desc: "MFA, Conditional Access, Defender for M365, Anti-phishing & DLP policies.",
  },
  {
    icon: FaDatabase,
    label: "Microsoft 365 Backup",
    desc: "Full protection for Exchange, OneDrive, SharePoint & Teams.",
  },
  {
    icon: FaClipboardCheck,
    label: "Compliance Setup",
    desc: "Microsoft Purview & Compliance Manager dashboards for HIPAA, GDPR, SOC 2 & more.",
  },
  {
    icon: FaPeopleArrows,
    label: "Collaboration Tool Enablement",
    desc: "Teams, SharePoint, OneDrive setup & file governance.",
  },
  {
    icon: FaShieldAlt,
    label: "Ransomware Protection",
    desc: "EDR , MDR , Backups",
  },
  {
    icon: FaCogs,
    label: "Custom Policies & Automation",
    desc: "Intune, device management, email routing, SSO integration.",
  },
  {
    icon: FaPhoneAlt,
    label: "24/7/365 Technical Support",
    desc: "Always-on helpdesk availability for your business.",
  },
  {
    icon: FaClock,
    label: "Monthly Support Hours",
    desc: "Troubleshooting, onboarding, mailbox recovery, reporting, and admin tasks.",
  },
];

export const SUPPORT_HOURS_USES = {
  icon: FaUsers,
  label: "Use Your Support Hours For",
  desc: "User onboarding & offboarding processes , Mailbox or license changes , Data recovery & backups , Security policy adjustments, Email delivery troubleshooting , Compliance and audit reporting , Setup of new M365 features , Advisory & optimization sessions. ",
};

export const AUDIT_BUNDLES_CONSTANTS = {
  title: "See More About Our Audit Bundles",
  intro: {
    heading: "What's Included?",
    desc: "The Audit Bundles are purpose-built for organizations in regulated industries such as finance, healthcare, education, and government. These bundles deliver a compliance-first approach to Microsoft 365 management — ensuring full visibility, traceability, and documentation aligned with leading regulatory standards (e.g., NCUA, PCI, SOC2).",
  },
  users: {
    heading: "Who Is It For?",
    list: [
      "Credit Unions & Financial Institutions",
      "Healthcare Providers",
      "Educational Institutions",
      "Government or Grant-Funded Organizations",
    ],
  },
  note: "These bundles ensure your Microsoft 365 environment meets compliance frameworks without requiring your internal team to manage ongoing controls or evidence gathering.",
};

export const PRICING_HEADING_CONSTANTS = {
  title: "Managed Microsoft 365 Services",
  sec_bundles: " Managed Security & Compliance Bundles ",
  services_bundles: " Managed Services Bundles ",
};

export const FOOTER_CONSTANTS = {
  text1: (
    <>
      Note : All Bundles Require a 12 Month Commitment .
      <br />
      <Balancer>
        Whether you are a growing business or an enterprise, we handle setup, security,
        compliance, and user support — so you can focus on running your business.
      </Balancer>
    </>
  ),
  btnText: "Get Started Now",
};
